!((document, Drupal, $) => {
  'use strict';

  // Toggle filter panel form
  $('.mobile-filter-trigger').on('click', function() {
    $(this)
      .parent()
      .siblings('.panel')
      .addClass('show');

    $('body').addClass('locked');
  });

  $('.panel .back-button').on('click', function() {
    $(this)
      .closest('.panel')
      .removeClass('show');

    $('body').removeClass('locked');
  });

  // Form submission
  $('#filterForm').submit(function(e) {
    const allInputs = $(this).find(':input');
    const formVals = [];
    allInputs.each(function() {
      var input = $(this);
      let fieldkey = input.attr('name');
      let fieldVal = input.val();
      let obj = {
        key: fieldkey,
        value: fieldVal
      };

      if (obj.key && obj.value) {
        formVals.push(obj);
      }
    });

    // Take back to results (remove panel screen panel)
    $(this)
      .closest('.panel')
      .removeClass('show');

    $('body').removeClass('locked');

    e.preventDefault();
  });

  // function searchFormChangeActions() {
  //   var $form = $(
  //     'body.path-search #views-exposed-form-search-page-search-exchanges'
  //   );
  //   var origForm = $form.serialize();
  //   var formSubmitButton = $form.find('.submit-button-wrap button');

  //   // Default submit button state for search form
  //   formSubmitButton.prop('disabled', true);

  //   $form.on('change input', function() {
  //     if ($form.serialize() !== origForm) {
  //       formSubmitButton.prop('disabled', false);
  //     }
  //     else {
  //       formSubmitButton.prop('disabled', true);
  //     }
  //   });
  // }
  // searchFormChangeActions();

  function selectDropdownValue(that) {
    // Reset class
    that
      .closest('.form-dropdown-list')
      .find('.dropdown-item')
      .removeClass('selected');

    // Add selected
    that.addClass('selected');

    // Update button to show selected value
    let toggleButton = that
      .closest('.form-dropdown-list')
      .siblings('.dropdown-toggle');

    let selectedValue = that.attr('href');
    let hiddenInput = toggleButton
      .closest('.form-group.dropdown')
      .find('.form-control.hide')
      .first();

    hiddenInput.attr('value', selectedValue.replace('#', ''));
    hiddenInput.change();
    toggleButton.html(that.text());
  }

  function displayFilterFields(inputName, selectedFilter) {
    if (inputName && inputName === 'type') {
      var formField = 'body.path-search .views-exposed-form .form-field-col';
      if (selectedFilter) {
        // all content types that have an initially hidden additional filter
        var dataTypeFilters = [
          'alert',
          'fee_schedule',
          'filing',
          'circular',
          'pilot_report'
        ];

        // Close and reset all dataType filters before selecting to open
        dataTypeFilters.forEach((filterName) => {
          var filter = $(formField + '.field_' + filterName + '_type_tax_ref');
          filter.removeClass('show');

          var defaultSelect = filter.find('.dropdown-item[href="#All"]');
          selectDropdownValue(defaultSelect);
        });

        // Toggle types if exists
        if (dataTypeFilters.includes(selectedFilter)) {
          $(formField + '.field_' + selectedFilter + '_type_tax_ref').addClass(
            'show'
          );
        }
      }
    }
  }

  function checkParamsForSearch() {
    let params = new URLSearchParams(window.location.search);
    if (params.has('type')) {
      displayFilterFields('type', params.get('type'));
    }
  }
  checkParamsForSearch();

  // For exposed filters on search page
  $('body.path-search .views-exposed-form .form-group .dropdown-item').on(
    'click',
    function() {
      var targetInput = $(this)
        .closest('.form-group')
        .find('input');
      var inputName = targetInput.attr('name');
      var selectedFilter = targetInput.val();

      displayFilterFields(inputName, selectedFilter);
    }
  );

  // For toggling search input on larger forms
  $('.views-exposed-form input.toggle-display').on('change', function() {
    var self = $(this);
    var selfId = self.attr('id');

    if (selfId === 'toggle-search-input') {
      self
        .closest('.columns')
        .find('.form-field-col.keys')
        .toggleClass('show');
    }
  });

  function preventScrollBehind() {
    var overlay = document.getElementsByClassName('panel')[0];

    // No mobile filter panel on this page — nothing to lock.
    if (!overlay) {
      return;
    }

    var clientYDefault = null;

    function isOverlayTotallyScrolled() {
      return overlay.scrollHeight -
      overlay.scrollTop <=
      overlay.clientHeight;
    }

    function disableRubberBand(event) {
      var clientY = event.targetTouches[0].clientY - clientYDefault;

      if (overlay.scrollTop === 0 && clientY > 0) {
        event.preventDefault();
      }

      if (isOverlayTotallyScrolled() && clientY < 0) {
        event.preventDefault();
      }
    }

    overlay.addEventListener('touchstart', function (event) {
      if (event.targetTouches.length === 1) {
        clientYDefault = event.targetTouches[0].clientY;
      }
    }, false,  {passive: true});

    overlay.addEventListener('touchmove', function (event) {
      if (event.targetTouches.length === 1) {
        disableRubberBand(event);
      }
    }, false,  {passive: true});
  }

  preventScrollBehind();

})(document, Drupal, jQuery);
